import { useAuth0 } from '@auth0/auth0-react'
import { Subscribe } from '@react-rxjs/core'
import React, { FC } from 'react'

import {
  ConfigurableProductDetailsFragment,
  SimpleProductDetailsFragment,
} from '../../../../graphql/magento'
import { Maybe, Money } from '../../../../graphql/search'
import useSiteMetadata from '../../../../hooks/useSiteMetadata'
import { useDispensaryContext } from '../../../../lib/dispensaries'
import { displayAttribute } from '../../../../utils/itemTools'
import { VariantPriceReactive, VariantPriceSkeleton } from '../ItemHeading'
import * as Styled from './styled'

export interface ItemHeadingWithLinkProps {
  className?: string
  item: ConfigurableProductDetailsFragment
  selectedVariant: SimpleProductDetailsFragment | null | undefined
  variantRetailPrice: Maybe<Money> | undefined
  tagline?: string | null
}

const ItemHeadingWithLink: FC<ItemHeadingWithLinkProps> = ({
  className,
  item,
  selectedVariant = null,
  variantRetailPrice,
  tagline = null,
}) => {
  const npn = displayAttribute({ item, selectedVariant, attribute: 'natural_product_number' })
  const { featureFlags } = useSiteMetadata() ?? {}
  const { isAuthenticated } = useAuth0()
  const dispensary = useDispensaryContext()
  const anonymousCart = featureFlags?.anonymousCart ?? false
  const showPrice = isAuthenticated || !!dispensary || anonymousCart

  return (
    <Styled.Container className={className}>
      <Styled.Link className="item-name" to={`/products/${item.url_key}`}>
        {item.name}
      </Styled.Link>
      <div className="robotoCondensed sku">
        SKU: {displayAttribute({ item, selectedVariant, attribute: 'sku' })?.toUpperCase()}
        <span className="npn">{npn ? `NPN: ${npn}` : ''}</span>
      </div>
      {tagline && <p className="item-tagline">{tagline}</p>}
      {showPrice && (
        <Subscribe fallback={<VariantPriceSkeleton />}>
          <VariantPriceReactive
            item={item}
            selectedVariant={selectedVariant}
            retailPrice={variantRetailPrice}
          />
        </Subscribe>
      )}
    </Styled.Container>
  )
}

export default ItemHeadingWithLink
